import TubliChatBot from "./TubliChatBot";

export default TubliChatBot;
